
// de_DE.js
const de_DE = {
    "ZHONGWEN":"Chinese",
    "YINGYU":"English",
    "XIBANYAYU":"Español",
    "DEYU":"Deutsch",
    "FAYU":"Français",
    "ALABOYU":"العربية",
    "EYU":"Русский",
    "MALAIYU":"Bahasa Malaysia",
    "YUENANYU":"Tiếng Việt",
    "TAIYU":"ภาษาไทย",
    "YINNIYU":"Bahasa Indonesia",
// components
    "XiaDanTiXing": "Bestellhinweis",
    "NH_GDDBH_": "Hallo, diese Bestellung enthält Produkte mit \"Schätzpreis\". Bitte warten Sie, bis der Kunde das Angebot bestätigt hat, bevor Sie zahlen. Möchten Sie die Bestellung wirklich aufgeben?",
    "QueRenXiaDan": "Bestellung bestätigen",
    "WoZaiKanKan": "Ich schaue mir nochmal an",
    "XSQBDZ": "Alle Adressen anzeigen",
// ChatRoom
    "ZBZCBQFH": "Emojis werden derzeit nicht unterstützt",
    "FaSongLianJie": "Link senden",
    "YiChangXiaoXi": "Ungewöhnliche Nachricht",
    "QingShuRu": "Bitte eingeben",
    "FaSong": "Senden",
// DateSelector
    "DQSJXYKSSJ": "Aktuelle Zeit ist kleiner als Startzeit",
    "DQSJCGJSSJ": "Aktuelle Zeit überschreitet Endzeit",
    "QuXiao": "Abbrechen",
    "NianYueRi": "Jahr Monat Tag",
    "ShiFen": "Stunde Minute",
    "QueDing": "Bestätigen",
    "Nian": "Jahr",
    "Yue": "Monat",
    "Ri": "Tag",
    "Shi": "Stunde",
    "Fen": "Minute",
// goods-list-card
    "Qi": "ab",
// goods-promotion
    "1GeCuXiao": "1 Promotion",
    "ChaKanZengPin": "Geschenkprodukte anzeigen",
    "JHDJSHS_1T": "Bis zum Ende der Aktion verbleiben: {d} Tage {h} Stunden {m} Minuten {s} Sekunden",
    "YHGZ_ZPBKD": "Promotionsregel: Geschenkprodukte können nicht kumuliert werden",
    "YHGZ_AZZGM": "Promotionsregel: Vorteile entsprechend der endgültigen Kaufmenge",
    "GuanBi": "Schließen",
// group-filtrate
    "QuanBu": "Alle",
    "ZWXGSJ": "Keine relevanten Daten",
    "ZuiDiJia": "Niedrigster Preis",
    "ZuiGaoJia": "Höchster Preis",
    "LeiXing": "Typ",
    "PinPai": "Marke",
    "BiaoQian": "Tag",
    "JiaGeQuJian": "Preisspanne",
    "SPMC_GG_BH_": "Produktname / Spezifikation / Artikelnummer / Erster Buchstabe",
    "ZuHeShaiXuan": "Kombinierte Filterung",
    "ChongZhi_CanShu": "Zurücksetzen",
// image-upload
    "ZDKSC1ZTP": "Maximal {num} Bilder hochladen",
    "ZYXSCTP": "Nur Bilder hochladen erlaubt",
    "SCTPDXBYXC": "Größe des hochgeladenen Bildes darf {size} nicht überschreiten",
    "QBYCFSCTP_": "Bitte keine doppelten Bilder hochladen oder stellen Sie sicher, dass die Bildnamen eindeutig sind",
    "ShangChuanChengGong": "Hochladen erfolgreich",
    "ZDKSC1Z": "Maximal {num} hochladen",
// keyboard
    "CCSLZDXZ": "Maximale Anzahl überschritten",
    "QiDingLiang": "Mindestbestellmenge",
    "ShouQi": "Einklappen",
    "ShanChu": "Löschen",
// MultiPicker
    "FanHui": "Zurück",
// order-cart
    "Dai": "Vor",
    "YiQuXiao": "Abgebrochen",
    "ZengPin": "Geschenkprodukt",
    "1Zhong": "{num} Arten",
    "1Jian": "1 Stück",
    "HeJi": "Gesamt",
    "DaiFu": "Ausstehend",
// order-promotion
    "_DDM1YZ1J_": "【Bei Bestellwert {targetPrice} Yuan {presentNum} Stück geschenkt】",
    "_DDM1YLJ1Y_": "【Bei Bestellwert {targetPrice} Yuan sofort {price} Yuan rabattiert】",
    "_DDM1YLX1Z_": "【Bei Bestellwert {targetPrice} Yuan sofort {discount} % Rabatt】",
    "DingDanCuXiao": "Bestellungsaktion",
// page-ad
    "DLCKJG": "Anmelden, um Preis zu sehen",
// page-floating
    "DianPuZhuYe": "Geschäftshomepage",
    "GouWuChe": "Warenkorb",
    "ZaiXianKeFu": "Online-Kundenservice",
    "GeRenZhongXin": "Persönliches Zentrum",
    "LianXiDianHua": "Kontakttelefon",
    "FanHuiDingBu": "Zum Anfang zurückkehren",
// page-null
    "ZBDYML": "Seite nicht gefunden",
    "KNWZCW_HZY": "Möglicherweise falsche URL oder Seite wurde gelöscht",
    "FanHuiShangJi": "Zur übergeordneten Seite zurückkehren",
    "FanHuiShouYe": "Zur Startseite zurückkehren",
// product-edit
    "SPQDBNWK": "Produktliste darf nicht leer sein",
    "WoZhiDaoLe": "Ich verstehe",
    "SFQRSCSP": "Möchten Sie das Produkt wirklich löschen?",
    "QueRen": "Bestätigen",
    "ZYXSRSZBQB": "Nur Zahlen eingeben erlaubt, maximal 2 Dezimalstellen",
    "ShangPinDanJia": "Produktpreis pro Einheit",
    "YSPYJ": "Ursprünglicher Grundpreis des Produkts",
    "QSRZDJG": "Bitte angegebenen Preis eingeben",
    "ShuLiang": "Menge",
    "DanWei": "Einheit",
    "DanJia": "Preis pro Einheit",
    "BeiZhu": "Bemerkung",
    "YiChuShangPin": "Produkt entfernen",
    "XiuGai": "Bearbeiten",
// yunshl
    "TPSLCCYXSZ": "Anzahl der Bilder überschreitet den zulässigen Wert!",
    "WJBDDY5M_QC": "Datei darf nicht größer als 5M sein, bitte neu auswählen",
    "TPSCWC": "Bildupload abgeschlossen",
// BusinessFilter
    "_DGSLM1JZ1J": "【Bei Bestellmenge {num} Stück {presentNum} Stück geschenkt】",
    "_M1JLXMJ1Y_": "【Bei {num} Stück sofort {price} Yuan pro Stück】",
    "_DHJJZ1Y_": "【Bestellpreis reduziert auf {price} Yuan】",
    "_M1JLXMJ1Z_": "【Bei {num} Stück sofort {discount} % Rabatt pro Stück】",
    "_YDHJD1Z_": "【Ursprünglicher Bestellpreis mit {discount} % Rabatt】",
    "YuJi": "Erwartet",
    "MMYDDR": "DD.MM.",
    "KaiShiFaHuo": "Versand beginnen",
    "_DGSLM1Z1_": "【Bei Bestellmenge {num} {presentNum} geschenkt】",
    "_M1LXM1Y_": "【Bei {num} sofort {price} Yuan pro】",
    "_M1LXM1Z_": "【Bei {num} sofort {discount} % Rabatt pro】",
    "DaiQueRen": "Ausstehend bestätigen",
    "DaiFaHuo": "Ausstehend versenden",
    "DaiShouHuo": "Ausstehend empfangen",
    "YiWanCheng": "Abgeschlossen",
    "DaiFuKuan": "Ausstehend bezahlen",
    "YiFuKuan": "Bezahlt",
    "YiZuoFei": "G storniert",
    "DaiShenHe": "Ausstehend prüfen",
    "DaiHeXiao": "Ausstehend abrechnen",
    "YiHeXiao": "Abgerechnet",
    "XianXiaZhiFu": "Offline-Zahlung",
    "ZhiNengDaoZhangShiBie": "Offline-Überweisung (intelligente Zahlungsbestätigung)",
    "WeiXinZhiFu": "WeChat-Zahlung",
    "KqZhiFu": "Kuaiqian-Zahlung (unterstützt WeChat/Alipay)",
    "ZFBZF": "Alipay-Zahlung",
    "YuEZhiFu": "Guthaben-Zahlung",
    "HuoDaoFuKuan": "Nachnahme",
    "DaiTuiHuo": "Ausstehend zurücksenden",
    "DaiTuiKuan": "Ausstehend erstattet",
    "ChuangJianDingDan": "Bestellung erstellen",
    "BianJiDingDan": "Bestellung bearbeiten",
    "TiJiaoDingDan": "Bestellung einreichen",
    "DingDanShenHe": "Bestellung prüfen",
    "CaiWuShenHe": "Finanzprüfung",
    "BoHui": "Ablehnen",
    "TianJiaShouKuan": "Zahlung hinzufügen",
    "ZaiXianZhiFu": "Online-Zahlung (unterstützt WeChat/Alipay/JD Pay/Yunshanfu)",
    "YinLianZhiFu": "UnionPay-Zahlung",
    "MercadoPagoZhiFu": "MercadoPago-Zahlung",
    "ShouKuanShenHe": "Zahlung prüfen",
    "ShouKuanZuoFei": "Zahlung stornieren",
    "ChuKu": "Auslagern",
    "ChuKuShenHe": "Auslagerung prüfen",
    "FaHuo": "Versenden",
    "TianJiaWuLiu": "Logistik hinzufügen",
    "XiuGaiWuLiu": "Logistik bearbeiten",
    "ChuKuZuoFei": "Auslagerung stornieren",
    "ShouHuo": "Empfangen",
    "DingDanHeZhun": "Bestellung genehmigen",
    "QuXiaoDingDan": "Bestellung stornieren",
    "CJTHD": "Retourenformular erstellen",
    "DaYin": "Drucken",
    "DaoChu": "Exportieren",
    "DingDanWanCheng": "Bestellung abgeschlossen",
    "QiangZhiWanCheng": "Erzwingen Abschluss",
    "DingDanZuoFei": "Bestellung stornieren",
    "MaiZeng": "Kaufen und erhalten",
    "ZhiJiang": "Sofort reduziert",
    "DaZhe": "Rabatt",
    "YuShou": "Vorverkauf",
    "DingDanManZeng": "Bestellung mit Gratisgeschenk bei Mindestbestellwert",
    "DingDanManJian": "Bestellung mit Rabatt bei Mindestbestellwert",
    "DingDanManZhe": "Bestellung mit Prozentsatzrabatt bei Mindestbestellwert",
    "XinRenQuan": "Neukunden-Coupon",
    "ManJianQuan": "Rabattcoupon bei Mindestbestellwert",
    "ShangPinQuan": "Produktcoupon",
    "DaiJieSuan": "Ausstehend abrechnen",
    "YiJieSuan": "Abgerechnet",
    "QuanBuShangPin": "Alle Produkte",
    "TuiJianShangPin": "Empfohlene Produkte",
    "XinPin": "Neue Produkte",
    "ReXiaoShangPin": "Beliebte Produkte",
    "ChangYongShangPin": "Oft verwendete Produkte",
// BusinessUtil
    "DaiShouKuan": "Ausstehend erhalten",
    "BuFenShouKuan": "Teilweise erhalten",
    "YiShouKuan": "Erhalten",
    "BXYFP": "Keine Rechnung benötigt",
    "ZZSPTFP": "Allgemeine Steuerrechnung",
    "ZZSZYFP": "Spezielle Steuerrechnung",
    "QiTaFaPiao": "Andere Rechnungen",
    "XianXia": "Offline",
    "WeiXin": "WeChat",
    "ZhiFuBao": "Alipay",
    "YuCunKuan": "Vorschussguthaben",
    "XianXiaZhuangZhang": "Offline-Überweisung",
    "XianShangZhiFu": "Online-Zahlung",
    "YCKZF": "Zahlung aus Vorschussguthaben",
    "DaiTiJiao": "Ausstehend einreichen",
    "KuaiDi": "Express",
    "SongHuoShangMen": "Nach Hause liefern",
    "ShangMenZiQu": "Selbstabholung",
    "WuLiuHuoYun": "Logistikfracht",
    "QiTa": "Andere",
// check-util
    "QSRBXY6WDM": "Bitte Passwort mit mindestens 6 Zeichen eingeben",
    "QSRBDY20WDM": "Bitte Passwort mit maximal 20 Zeichen eingeben",
    "MMGSCW": "Falsches Passwortformat",
// common-utils
    "SJCW_QLXKF": "Datenfehler, bitte kontaktieren Sie den Kundenservice",
    "ZBZCQD": "Anwesenheitscheck derzeit nicht unterstützt",
    "HuJiao": "Anrufen",
    "DLZHBCZ": "Anmeldekonto existiert nicht",
    "QLXGLYKT": "Bitte kontaktieren Sie den Administrator zur Aktivierung",
    "GQYZHBJY": "Dieses Unternehmenskonto ist deaktiviert",
    "QLXYSDH": "Bitte kontaktieren Sie Yunshang Order",
    "GQYZHSYQJS": "Testphase des Unternehmenskontos abgelaufen",
    "GQYZHYGQL": "Dieses Unternehmenskonto ist abgelaufen",
    "XYXFCNSY": "Erneuerung erforderlich, um weiterzuverwenden",
    "GQYBCZCZH": "Dieses Unternehmen hat dieses Konto nicht",
    "NDDHZHYBQY": "Ihr Bestellkonto wurde von Unternehmen 1 deaktiviert, Anmeldung nicht möglich. Bitte kontaktieren Sie den Administrator",
    "NYBSQY1DHZ": "Sie sind kein Kooperationskunde von Unternehmen 1 mehr, Anmeldung nicht möglich. Bitte kontaktieren Sie den Administrator",
    "NDDPYBTY_B": "Ihr Geschäft wurde deaktiviert, Anmeldung nicht möglich. Bitte kontaktieren Sie den Administrator",
    "GZHWKTDSZB": "Diese Funktion für Spezielles Leuchten-Programm ist für dieses Konto nicht aktiviert. Bitte kontaktieren Sie den Administrator",
    "WXSQYZYGQ": "WeChat-Berechtigungsvalidierung abgelaufen",
    "WXSQSB": "WeChat-Berechtigung fehlgeschlagen",
    "WXSQSB_CWX": "WeChat-Berechtigung fehlgeschlagen, Fehlermeldung",
    "DengLuGuoQi": "Anmeldung abgelaufen",
    "DLGQ_QCXDL": "Anmeldung abgelaufen, bitte neu anmelden",
// data-constant
    "ShangJia": "Online stellen",
    "YiXiaJia": "Offline genommen",
    "YiJinYong": "Deaktiviert",
    "YiQiYong": "Aktiviert",
    "YiTingYong": "Pausiert",
    "KeHuZhuCe": "Kundenregistrierung",
    "XinZengDaoRu": "Neu importieren",
    "DDDSH": "Ausstehend Bestellung prüfen",
    "DCWSH": "Ausstehend Finanzprüfung",
    "DaiChuKu": "Ausstehend auslagern",
    "DCK_BF_": "Ausstehend auslagern (teilweise)",
    "DFH_BF_": "Ausstehend versenden (teilweise)",
    "DSH_BF_": "Ausstehend empfangen (teilweise)",
    "DSK_BF_": "Ausstehend erhalten (teilweise)",
    "WTHSQ": "Keine Retourenanfrage",
    "THDSH": "Retoure ausstehend prüfen",
    "THCLZ": "Retoure in Bearbeitung",
    "THYWC": "Retoure abgeschlossen",
    "DYDHD": "Bestellformular drucken",
    "DYFHD": "Versandliste drucken",
    "DCDHD": "Bestellformular exportieren",
    "DCFHDWE_P": "Versandliste als Excel/PDF exportieren",
    "TuiDanZuoFei": "Retourenformular stornieren",
    "DTHSH": "Ausstehend Retoure prüfen",
    "DaiRuKu": "Ausstehend einlagern",
    "DRK_BF_": "Ausstehend einlagern (teilweise)",
    "DFK_BF_": "Ausstehend bezahlen (teilweise)",
    "ChuangJianTuiDan": "Retourenformular erstellen",
    "BianJiTuiDan": "Retourenformular bearbeiten",
    "TiJiaoTuiDan": "Retourenformular einreichen",
    "TuiHuoShenHe": "Retoure prüfen",
    "RuKu": "Einlagern",
    "RuKuShenHe": "Einlagerung prüfen",
    "RuKuZuoFei": "Einlagerung stornieren",
    "TianJiaFuKuan": "Zahlung hinzufügen",
    "FuKuanZuoFei": "Zahlung stornieren",
    "FuKuanShenHe": "Zahlung prüfen",
    "TuiDanWanCheng": "Retourenformular abgeschlossen",
    "QiTaChuKu": "Andere Auslagerung",
    "XiaoShouChuKu": "Verkaufsauslagerung",
    "PanKuiChuKu": "Inventurverlust-Auslagerung",
    "DiaoBoChuKu": "Umlagerungsauslagerung",
    "CaiGouTuiHuo": "Einkaufsretoure",
    "TuiHuoRuKu": "Retoureneinlagerung",
    "CaiGouRuKu": "Einkaufeinlagerung",
    "QiTaRuKu": "Andere Einlagerung",
    "PanYingRuKu": "Inventurgewinneinlagerung",
    "DiaoBoRuKu": "Umlagerungseinlagerung",
    "CJCGD": "Einkaufsliste erstellen",
    "BJCGD": "Einkaufsliste bearbeiten",
    "TJCGD": "Einkaufsliste einreichen",
    "CGDZF": "Einkaufsliste stornieren",
    "CGDWC": "Einkaufsliste abgeschlossen",
    "CGTHZF": "Einkaufsretoure stornieren",
    "CGTHWC": "Einkaufsretoure abgeschlossen",
    "THDDY": "Retourenformular drucken",
    "THDDC": "Retourenformular exportieren",
    "CKDDY": "Auslagerungsliste drucken",
    "CKDDC": "Auslagerungsliste exportieren",
    "GLDZH": "Verwaltungsaccount",
    "DHDZH": "Bestellaccount",
    "ShenHeTongGuo": "Prüfung bestanden",
    "SHBTG": "Prüfung nicht bestanden",
    "WuXuFaPiao": "Keine Rechnung benötigt",
    "DaiKeXiaDan": "Bestellung für Kunden aufgeben",
    "ZiZhuXiaDan": "Selbstbestellung",
    "PCShangCheng": "PC-Shop",
    "APPShangCheng": "APP-Shop",
    "TVShangCheng": "TV-Shop",
    "WeiXinShangCheng": "WeChat-Shop",
    "ShouJiShangCheng": "Mobil-Shop",
    "ADDXSMLTC": "Provision nach Verkaufsgewinn der Bestellung",
    "ADDXSSRTC": "Provision nach Verkaufseinnahme der Bestellung",
    "AKHSSYG": "Nach Mitarbeiter des Kunden",
    "AnZhiDanRen": "Nach Ersteller",
    "ATHJEBLKCT": "Provisionsbetrag proportional zum Retourenbetrag abziehen",
    "DDYTHBJXTC": "Keine Provision bei Retouren in der Bestellung",
    "DaiDaKuan": "Ausstehend überweisen",
    "WeiKaiShi": "Noch nicht begonnen",
    "JinXingZhong": "Läuft",
    "YiGuoQi": "Abgelaufen",
// Utils.js
    "YouHuo": "Auf Lager",
    "WuHuo": "Ausverkauft",
    "Yi": "Millionen",
    "QianWan": "Zehn Millionen",
    "BaiWan": "Millionen",
    "Wan": "Tausend",
    "Sheng1Tian": "1 Tag übrig",
    "Sheng1XiaoShi": "1 Stunde übrig",
    "Miao": "Sekunde",
    "1Miao": "1 Sekunde",
    "GangGang": "Gerade eben",
    "1FenZhongQian": "1 Minute zuvor",
    "1XiaoShiQian": "1 Stunde zuvor",
    "1TianQian": "1 Tag zuvor",
    "1GeYueQian": "1 Monat zuvor",
    "1NianQian": "1 Jahr zuvor",
    "WeiZhiLeiXing": "Unbekannter Typ",
// WechatUtil
    "YYGBCDSP_K": "Ein tolles Produkt, schauen Sie es sich an",
    "ZanWeiSheZhi": "Noch nicht eingestellt",
// app
    "HQWXSQXX": "WeChat-Berechtigungsinformationen abrufen",
// flexible
    "JGJYYDMBQ": "Skalierungsfaktor basierend auf vorhandenen Meta-Tags einstellen",
// index
    "NLJZZ": "Lädt...",
// routes
    "ShangPinMingXi": "Produktdetails",
    "ShangPinLeiBie": "Produktkategorie",
    "QXZFPNR": "Bitte Rechnungsinhalt auswählen",
    "QXZFPLX": "Bitte Rechnungstyp auswählen",
    "QTXFPTT": "Bitte Rechnungstitel eingeben",
    "FaPiaoTaiTou": "Rechnungstitel",
    "NSRSBH": "Steueridentifikationsnummer",
    "FaPiaoNeiRong": "Rechnungsinhalt",
    "FaPiaoXinXi": "Rechnungsinformationen",
    "KaiJuFaPiao": "Rechnung ausstellen",
    "FaPiaoLeiXing": "Rechnungstyp",
    "Han": "Enthält",
    "WeiHan": "Enthält nicht",
    "Shui": "Steuer",
    "QSRFPTT": "Bitte Rechnungstitel eingeben",
    "QSRNSRSBH": "Bitte Steueridentifikationsnummer eingeben",
// cart-bill
    "YiManZu_Man": "Bedingung erfüllt【bei",
    "ZaiGou": "Weiter einkaufen",
    "YMZ_DHJJZ": "Bedingung erfüllt【Bestellpreis reduziert auf",
    "JianJiangZhi": "Stück reduziert auf",
    "YMZ_YDHJD": "Bedingung erfüllt【Ursprünglicher Bestellpreis mit",
    "JianMeiJian": "Stück pro Stück",
    "SYTCSLW0_WFJRGWC": "Verbleibende Paketmenge ist 0, kann nicht in den Warenkorb hinzugefügt werden",
    "QingXuanXeShangPin": "Bitte Produkt auswählen!",
    "GSPYXJ": "Dieses Produkt ist offline genommen!",
    "ZJ2TN": "In den letzten 2 Tagen",
    "QDQCXJSP": "Sind Sie sicher, dass Sie offline genommene Produkte löschen möchten?",
    "QingChuChengGong": "Löschung erfolgreich",
    "TCSPBKJRGWC_QQXTCSPZYRGW": "Paketprodukte können nicht in den Warenkorb hinzugefügt werden. Bitte Paketprodukte entfernen, bevor Sie sie in den Warenkorb verschieben!",
    "SPSLBN": "Produktmenge kann nicht",
    "TaoCanHan": "Paket enthält",
    "TaoCan": "Paket",
    "QHDSL": "Bitte Menge prüfen",
    "SPSLBNDY": "Produktmenge darf nicht weniger als",
    "XianDingLiang": "Maximalbestellmenge",
    "YiRuShouCang": "Zur Sammlung hinzufügen",
    "QuanXuan": "Alle auswählen",
    "JianZeng": "Stück geschenkt",
    "JianLiXiang_Man": "Stück sofort【bei",
    "Yuan_": "Yuan】",
    "Zhe_": "% Rabatt】",
    "KCBZ_WFJRGWC": "Lagerbestand unzureichend, kann nicht in den Warenkorb hinzugefügt werden",
    "XDJEDYDY": "Bestellbetrag größer oder gleich",
    "WYXJHYSXDSP": "Keine offline genommenen oder ungültigen Produkte!",
    "DYQDL": "Unter Mindestbestellmenge",
    "ZSPG1J": "{count} Produkte, insgesamt {number} Stück",
    "WanCheng": "Abschließen",
    "BianJi": "Bearbeiten",
    "You": "Es gibt",
    "ZSPBFHYQ_W": "Produkte, die den Anforderungen nicht entsprechen, nicht markiert. Klicken Sie, um die Standardadresse zu überprüfen",
    "SPSLBNGY": "Produktmenge darf nicht mehr als",
    "JXDJ_CKXYGBFHYQSP": "Weiter klicken, um das nächste nicht passende Produkt anzuzeigen",
    "XiaDan": "Bestellen",
    "JianJiang": "Stück reduziert",
    "QRYCSP": "Produkt wirklich entfernen?",
    "QXZXDSP": "Bitte Bestellprodukte auswählen",
    "KCBZ_QCXXZ": "Lagerbestand unzureichend, bitte neu auswählen!",
    "KuCun": "Lagerbestand",
    "YCKXD": "Yuan, um bestellen zu können",
    "QDSCSP": "Produkt wirklich zur Sammlung hinzufügen?",
    "ShouCangChengGong": "Zur Sammlung hinzugefügt",
    "GYXDL": "Über Maximalbestellmenge",
    "LiSheng": "Sofort sparen",
    "GWCHSKD_QGYGB": "Der Warenkorb ist noch leer, gehen Sie einkaufen",
    "QuGuangGuang": "Einkaufen gehen",
    "QCXJSP": "Offline genommene Produkte löschen",
    "ZongE": "Gesamtsumme",
    "YouHui": "Rabatt",
// 接上文继续翻译
// cart-list
    "QXZJHRQ": "Bitte Lieferdatum auswählen",
    "FuJiaFeiYong": "Zusatzkosten",
    "ZhongShangPin_Gong": "Produktarten, insgesamt",
    "PeiSongShiJian": "Lieferzeit",
    "QXZPSSJ": "Bitte Lieferzeit auswählen",
    "DingDanJinE": "Bestellbetrag",
    "SCFJ_ZD4Z": "Anhänge hochladen, max. {num} Stück, einzelnes nicht über {size}",
    "KeYongShangPin": "Verwendbare Produkte",
    "ShiYongShuoMing": "Verwendungsanleitung",
    "YouXiaoQi": "Gültigkeit",
    "Man": "bei",
    "BZZBZCTSFH": "Bemerkungen unterstützen derzeit keine Sonderzeichen",
    "QingXuanZe": "Bitte auswählen",
    "KaiPiaoXuJia": "Zusatzkosten für Rechnung",
    "PeiSongFangShi": "Lieferart",
    "ShangPinZongJia": "Gesamtpreis der Produkte",
    "YouHuiQuan": "Gutschein",
    "ZhangKeXan": "auswählbar",
    "DDJEWMZ": "Bestellbetrag nicht erreicht",
    "WDYHQ": "Meine Gutscheine",
    "KYYHQ": "Verwendbare Gutscheine",
    "YuanKeYong": "Yuan anwendbar",
    "ChaKanDingDan": "Bestellung anzeigen",
    "ShangPinHanShui": "Produkt enthält Steuer",
    "SPWHS": "Produkt enthält keine Steuer",
    "GeDian": "Punkte",
    "QueRenDingDan": "Bestellung bestätigen",
    "XZSHDZ": "Neue Lieferadresse hinzufügen",
    "ShangPinQingDan": "Produktliste",
    "WKYYHQ": "Keine verwendbaren Gutscheine",
    "HuChi": "Gegenseitig ausschließend",
    "DaiJinQuan": "Gutschein",
    "YunFei": "Versandkosten",
    "ShuiFei": "Steuerkosten",
    "WKYYY": "Grund für Unverwendbarkeit",
    "YHQYGQ": "Gutschein abgelaufen",
    "WDYHQSYSJ": "Noch nicht Zeit für Gutscheinverwendung",
    "ZDSPJEWMZ": "Betrag des angegebenen Produkts nicht erreicht",
    "BKYYHQ": "Unverwendbare Gutscheine",
    "RMBJE": "RMB-Betrag",
// cart-presale-order
    "QXZPSFS": "Bitte Lieferart auswählen",
    "1ZSP_G": "1 Produktart, insgesamt",
    "YSSP_YJ": "Vorkaufsprodukt, voraussichtlich",
    "JiaoHuoRiQi": "Lieferdatum",
    "GMJLY": "Nachricht an Verkäufer",
// scan-to-cart
    "ZhengZaiChuLi...": "Verarbeitet...",
    "FSCSP": "Nicht Shop-Produkt",
    "ZZCLTXM": "Barcode wird verarbeitet...",
    "SPTJCG": "Produkt erfolgreich hinzugefügt",
    "QSTXM": "Bitte Barcode scannen",
    "SFSCDQSP": "Aktuelles Produkt löschen?",
    "BQ_ZBDXGSP": "Entschuldigung, kein zugehöriges Produkt gefunden",
    "XuanZeDanWei": "Einheit auswählen",
    "JRGWC": "In Warenkorb",
    "QXXZDJRSP": "Bitte zu hinzufügende Produkte zuerst auswählen",
    "ZhengZaiChuLi": "Verarbeitet",
    "JRGWCCG": "Erfolgreich in Warenkorb hinzugefügt",
    "ZanWuShangPin": "Keine Produkte",
// earn-brokerage-share
    "XTYJBNFZSP": "System hat Produktlink für Sie kopiert!",
    "NKYHDDYDYJ": "Sie können entsprechende Provision erhalten. Provision kann in \"Meine",
    "LiChaKan": "anzeigen",
    "WeiXinHaoYou": "WeChat-Freunde",
    "ErWeiMa": "QR-Code",
    "CASBEWM": "Längeres Drücken zum Erkennen des QR-Codes",
    "FZSB_QCXFZ": "Kopieren fehlgeschlagen, bitte erneut versuchen!",
    "TWEWM": "Bild-Text-QR-Code",
    "BCDXC": "In Album speichern",
    "CATPBCDXC": "Längeres Drücken auf Bild, um in Album zu speichern",
    "FuZhiLianJie": "Link kopieren",
    "FXZYJ": "Teilen und Provision verdienen",
    "YJZGKZQYJ": "Voraussichtliche maximale Provision",
// goods-share
    "FXSPGLSKH": "Produkt an Endverbraucher teilen",
    "FXHJSCNZSD": "Nach dem Teilen wird Ihr exklusives mobiles Mini-Shop erstellt. Sie können Preise der Produkte im Shop festlegen, Ihre Kontaktdaten eingeben und Verbraucher anlocken, vor Ort einzukaufen.",
    "WSCDQJG_ND": "Aktueller Preis im Mini-Shop: Ihr Bestellpreis ×",
    "DaiSheZhi": "Ausstehend einstellen",
    "PengYouQuan": "Freundeskreis",
    "GGFXSZ": "Freigabeeinstellungen ändern",
// wechat-login
    "QXSRZH": "Bitte zuerst Konto eingeben",
    "MMGSCW_6_20W": "Falsches Passwortformat (6-20 Buchstaben oder Ziffern)",
    "BDYYZH": "Bestehendes Konto binden",
    "WXKJDL": "WeChat-Schnelllogin",
    "BangDingZhangHao": "Konto binden",
    "YYZH_QDL": "Bereits Konto, zum Login",
    "ZCXZH": "Neues Konto registrieren",
    "HuanYingNi": "Willkommen",
    "ZH_SJHM": "Konto/Handynummer",
    "MiMa": "Passwort",
    "QDLHCZ": "Bitte zuerst anmelden, bevor Sie handeln",
// add-to-cart
    "KCBZ_BNTJG": "Lagerbestand unzureichend, kann nicht mehr hinzugefügt werden",
// combined-pay-online
    "ZhiFuChengGong": "Zahlung erfolgreich!",
    "ZFSB_QCXCS": "Zahlung fehlgeschlagen, bitte erneut versuchen!",
//
    "QXXZGG": "Bitte zuerst Spezifikation auswählen",
    "SXGGX": "Ausgewählte Spezifikation benötigt",
    "GMSLXYQDL_": "Kaufmenge unter Mindestbestellmenge, bitte erneut kaufen!",
    "GMSLDYXDL_": "Kaufmenge über Maximalbestellmenge, bitte erneut kaufen!",
    "ShangPinBianHao": "Produktnummer",
    "QiDing": "Mindestbestellung",
    "SXGGDGSLBK": "Bestellmenge für ausgewählte Spezifikation darf nicht über",
    "KCBZ_BNTJ": "Lagerbestand unzureichend, kann nicht hinzugefügt werden",
    "QXXZSP": "Bitte zuerst Produkt auswählen",
    "SLBNW0": "Menge darf nicht 0 sein",
    "QXZGG": "Bitte Spezifikation auswählen",
    "LiJiYuDing": "Sofort reservieren",
// nav
    "ShouYe": "Startseite",
    "ShangPin": "Produkte",
    "DingDan": "Bestellungen",
    "WoDe": "Meine",
// pay-online
    "ZhiFuQuXiao": "Zahlung abbrechen",
// account-log
    "ShangPinYongJin": "Produktprovision",
    "YaoQingJiangLi": "Einladungsprämie",
    "TiXian": "Abheben",
    "TiXianBoHui": "Abhebung abgelehnt",
    "ZhuanWeiYuE": "In Guthaben umwandeln",
    "Jin7Tian": "Letzte 7 Tage",
    "Jin30Tian": "Letzte 30 Tage",
    "ShouZhiMingXi": "Einnahmen- und Ausgaben Details",
    "ZanWuShuJu": "Keine Daten",
// client-statistics
    "WoDeKeHu": "Meine Kunden",
    "WoDeYaoQing": "Meine Einladungen",
// distribution-home
    "LeiJiKeHu": "Kumulierte Kunden",
    "LeiJiDingDan": "Kumulierte Bestellungen",
    "YaoQingHaoYou": "Freunde einladen",
    "LeiJiYaoQing": "Kumulierte Einladungen",
    "LJSY_Y_": "Kumulierte Einnahmen (Yuan)",
    "BHDJS": "Enthält ausstehende Abrechnung",
    "J7TSY_Y_": "Einnahmen der letzten 7 Tage (Yuan)",
    "J7TXZKH_R_": "Neue Kunden der letzten 7 Tage (Personen)",
    "KTXYJ": "Abhebbare Provision",
    "XYJYO": "Noch mehr anstrengen",
    "ChangJianWenTi": "Häufig gestellte Fragen",
    "Q_ZMYJX_TG": "F: Wie funktioniert \"Werben und Geld verdienen\"?",
    "A_FXDPND_Z_": "A: Teilen Sie Links zu Seiten mit dem \"Verdienen\"-Symbol im Shop, um Freunde anzuziehen, die darauf klicken. Wenn Freunde registrieren (Kundenbeziehung ist auf Registrierung = Bindung eingestellt) oder bestellen (Kundenbeziehung ist auf Bestellung = Bindung eingestellt) und Produkte mit dem \"Verdienen\"-Symbol im Shop kaufen, wird dies nach einer bestimmten Berechnungsmethode als Ihre Einnahmen aus \"Werben und Geld verdienen\" gewertet.",
    "Q_RHJS_TGZ": "F: Wie werden die Einnahmen aus \"Werben und Geld verdienen\" berechnet?",
    "A_MGD_Z_TBD": "A: Jedes Produkt mit dem \"Verdienen\"-Symbol hat einen bestimmten Provisionsanteil. Ohne dieses Symbol nehmen die Produkte nicht an \"Werben und Geld verdienen\" teil. Nachdem Freunde erfolgreich über Ihren Freigabelink bezahlt haben, wird die Provision entsprechend dem Provisionsanteil jedes Produkts in der Bestellung berechnet (Provision für nicht beteiligte Werbung ist 0), und schließlich summiert sich dies zu den Provisionseinnahmen für diese Bestellung. Bei der Berechnung der Einnahmen werden Versandkosten, Rückerstattungen, Rabatte bei Mindestbestellwert usw. abgezogen, der Endverkaufspreis gilt.",
    "Q_TGZQ_DSY": "F: Wann werden die Einnahmen aus \"Werben und Geld verdienen\" gutgeschrieben?",
    "A_HYTGNDFX": "A: Nachdem Freunde erfolgreich über Ihren Freigabelink bezahlt haben, können Sie diese Werbung in den Werbebestellungen im Verkaufszentrum sehen, der Status ist \"Ausstehend abrechnen\". Nachdem der Kunde die Lieferung bestätigt hat und die Bestellung abgeschlossen und abgerechnet ist, werden diese Einnahmen automatisch auf Ihr persönliches Konto übertragen und können jederzeit abgehoben werden.",
    "Q_LJKH_LJY": "F: Keine Avatare oder Namen in der Liste der kumulierten Kunden und Einladungen?",
    "A_WXYQZYGZ": "A: WeChat erfordert, dass nur das Folgen eines zertifizierten Dienstkontos Avatare und Namen ermöglicht. Kunden von Shops mit zertifizierten Dienstkonten folgen dem öffentlichen Shop-Konto. Nicht zertifizierte Dienstkonten folgen dem \"Yunshang Order\"-öffentlichen Konto und klicken dann auf eine beliebige ProduktDetailseite des Shops, um Avatare und Namen abzurufen.",
    "Q_WSMWASSG": "F: Warum erhalte ich keine Werbungseinnahmen, obwohl ich gemäß den obigen Regeln geteilt habe?",
    "A_1_HYKNBW": "A: 1. Freunde haben eventuell keine Kundenbeziehung mit Ihnen hergestellt (Freunde klicken auf Links anderer Verkäufer, um sich zu registrieren oder zu bestellen) 2. Wenn Freunde Ihren Freigabelink außerhalb der WeChat-Umgebung öffnen (z. B. im Standardbrowser des Telefons) und der Browser keine Cookies aktiviert hat, kann die Kundenbeziehung nicht aufgezeichnet werden, d. h. keine Werbebestellungen aufgezeichnet 3. Wenn keine Werbebestellungen trotz der obigen Punkte aufgezeichnet werden, wenden Sie sich bitte an das Personal",
//
    "XiaoShouZhongXin": "Verkaufszentrum",
// generalize-goods
    "SPMC_GG_BH": "Produktname / Spezifikation / Nummer",
    "YuJiZhuan": "Voraussichtlich verdienen",
// invitation-home
    "YaoQingKa": "Einladungskarte",
    "YNYQJR_TGY": "Lade dich ein, mitzumachen und Belohnungen durch Werbung zu gewinnen",
    "DJBCDXC": "Klicken Sie, um im Album zu speichern",
    "JYQKFSGHY_": "Senden Sie die Einladungskarte an Freunde, um Belohnungen für das Werben des Shops zu erhalten",
// join-home
    "HuanYingJiaRu": "Willkommen bei uns",
    "YQNCW": "Wir laden Sie ein,",
    "LiJiJiaRu": "Sofort beitreten",
// order-statistics
    "YuJiYongJin": "Voraussichtliche Provision",
    "YongJin": "Provision",
    "YuJiJiangLi": "Voraussichtliche Belohnung",
    "JiangLi": "Belohnung",
    "SPTGDD": "Produktwerbebestellungen",
    "YQJLDD": "Einladungsbelohnungsbestellungen",
// performance-statistics
    "YeJiTongJi": "Leistungsstatistik",
    "LJKH_R_": "Kumulierte Kunden (Personen)",
    "SPYJ_Y_": "Produktprovision (Yuan)",
    "HanDaiJieSuan": "Enthält ausstehende Abrechnung",
    "XGMCJS": "Erklärungen zu relevanten Begriffen",
    "KeHu": "Kunde",
    "HFXYBDLKHG": "Käufer oder Vertriebler, der eine Kundenbeziehung mit dem Vertriebler gebunden hat",
    "YaoQing": "Einladung",
    "FXYCGYQDXJ": "Untergeordnete Vertriebler, die erfolgreich von einem Vertriebler eingeladen wurden",
    "FXYTJKHGMH": "Provision, die ein Vertriebler erhält, nachdem er einen Kunden empfohlen und dieser kauft",
    "XJFXYTGSPH": "Belohnung, die der Obergeordnete erhält, nachdem der untergeordnete Vertriebler Produkte beworben hat",
// posters-promoting
    "NiCheng": "Spitzname",
    "HaiBaoTuiGuang": "Plakatwerbung",
    "JHBFSGHY_T": "Senden Sie das Plakat an Freunde, um Belohnungen für das Werben des Shops zu erhalten",
// settlement-home
    "JieSuanZhongXin": "Abrechnungszentrum",
    "KTXJE": "Abhebbarer Betrag",
    "TiXianJiLu": "Abhebungsrecords",
// withdraw-account
    "KHRXMBNWK": "Name des Kontoinhabers darf nicht leer sein!",
    "KHHBNWK": "Bank darf nicht leer sein!",
    "YHKHBNWK": "Kontonummer darf nicht leer sein!",
    "SFZTPBNWK": "Foto des Ausweises darf nicht leer sein!",
    "YHKTPBNWK": "Foto der Bankkarte darf nicht leer sein!",
    "BaoCunChengGong": "Speichern erfolgreich!",
    "SCSFZ": "Ausweis hochladen",
    "SCYHK": "Bankkarte hochladen",
    "BaoCun": "Speichern",
    "TiXianZhangHu": "Abhebungskonto",
    "TS_QTXZSXX": "Hinweis: Bitte geben Sie echte Informationen ein. Abhebungen sind erst nach erfolgreicher Prüfung möglich",
    "KHRXM": "Name des Kontoinhabers",
    "KaiHuHang": "Bank",
    "YinhangKaHao": "Bankkartennummer",
    "QSRZSXM": "Bitte realen Namen eingeben",
    "QSRKHHMC": "Bitte Namen der Bank eingeben",
    "QSRYHKH": "Bitte Bankkartennummer eingeben",
// withdraw-deposit
    "QXSZTXZH": "Bitte zuerst Abhebungskonto einrichten",
    "QuSheZhi": "Zur Einrichtung",
    "JEXY10Y_BKT": "Betrag kleiner als 10 Yuan, nicht abhebbar!",
    "JECGKTXJE": "Betrag übersteigt den abhebbaren Betrag!",
    "CGDRKTXSX_": "Tägliches Abhebungslimit überschritten, tägliches Abhebungslimit beträgt 20000 Yuan!",
    "QueDingJiang": "Sind Sie sicher, dass Sie",
    "ZhuanDaoYuE": "in Guthaben umwandeln möchten?",
    "1_JEDY10YSB": "1. Beträge unter 10 Yuan sind nicht abhebbar;",
    "2_BCTXDZSJ": "2. Die Zahlungsdauer für diese Abhebung beträgt innerhalb von 5 Werktagen nach erfolgreicher Einreichung der Abhebungsanfrage, das tägliche Abhebungslimit beträgt 20000 Yuan;",
    "3_GBSRWHSS": "3. Dieser Ertrag ist steuerpflichtig. Bitte melden und zahlen Sie persönliche Einkommensteuern bei den zuständigen Steuerbehörden!",
    "4_ZDYEKYYS": "4. Umgewandeltes Guthaben kann für Einkäufe im Shop verwendet werden;",
    "TXSQCG_QDD": "Abhebungsanfrage erfolgreich, bitte warten Sie auf Prüfung",
    "JEDYKTXJE_": "Betrag größer als der abhebbare Betrag, kann nicht in Guthaben umgewandelt werden!",
    "ZZYECG_QDG": "Guthabenübertragung erfolgreich, bitte im persönlichen Zentrum prüfen!",
    "BenCiTiXian": "Diese Abhebung",
    "ZhuangDaoYuE": "In Guthaben umwandeln",
    "TiXianDao": "Abheben auf",
    "JEW0BKZZYE": "Betrag 0 kann nicht in Guthaben umgewandelt werden!",
    "DRTXSX2WY": "Tägliches Abhebungslimit 20000 Yuan",
    "QuanBuTiXian": "Alle abheben",
    "QueRenTiXian": "Abhebung bestätigen",
// goods-filter-tab
    "ZuiChangGouMai": "Am häufigsten gekauft",
    "MoRenPaiXu": "Standard sortieren",
    "ZongHe": "Kombiniert",
    "FenLei": "Kategorie",
    "XiaoLiangYouXian": "Nach Verkaufszahl priorisieren",
    "XiaoLiang": "Verkaufszahl",
    "JiaGe": "Preis",
    "ShaiXuan": "Filtern",
    "ZuiJinGouMai": "Kürzlich gekauft",
    "CuXiaoYouXian": "Nach Promotion priorisieren",
    "QuanBuFenLei": "Alle Kategorien",
    "ZhiKanCuXiao": "Nur Promotion anzeigen",
    "XuanZeFenLei": "Kategorie auswählen",
    "QXZFL": "Bitte Kategorie auswählen",
// goods-list-default
    "ZWXGSP": "Keine zugehörigen Produkte",
// goods-brand-list
    "PinPaiHui": "Marken Sammlung",
// goods-classify-filter
    "TuiJianFenLei": "Empfohlene Kategorien",
    "ShangPinFenLei": "Produktkategorien",
    "GengDuo": "Mehr",
// goods-detail
    "DLZHBSDQQY": "Anmeldekonto ist nicht das aktuelle Unternehmenskonto",
    "GXNHQ": "Glückwunsch, Sie erhalten",
    "SZWSCJGH_C": "Nur nach Einstellung des Mini-Shop-Preises teilbar",
    "JHDJSHS_": "Bis zum Ende der Aktion verbleiben",
    "DLHKFX": "Nach Anmeldung teilbar",
    "ZZHQXX_QSH": "Informationen werden abgerufen, bitte später erneut versuchen",
    "Zhang": "Stücke",
    "Tian": "Tage",
    "QXZGGZQPD": "Bitte zuerst Spezifikation auswählen, um Beleuchtung zu konfigurieren!",
    "Yuan": "Yuan",
    "XS_F_M": "Stunden/Minuten/Sekunden",
// integral
    "WoDeJiFen": "Meine Punkte",
    "DaBaiLe": "Hat geschlagen",
    "JiFen": "Punkte",
    "DeHuiYuan": "der Mitglieder",
    "ZhuanJiFen": "Punkte verdienen",
    "JiFenMingXi": "Punkte Details",
    "HuanLiPin": "Geschenke einlösen",
    "CKGDHL": "Mehr tolle Geschenke anzeigen",
    "ChaDingDan": "Bestellung überprüfen",
// integral-convert
    "DHSLBNCG": "Anzahl der Einlösungen darf nicht übersteigen",
    "DuiHuanShuLiang": "Einlösungsmenge",
    "SuoXuJiFen": "Benötigte Punkte",
// integral-detail
    "LiPinXiangQing": "Geschenkdetails",
    "WoYaoDuiHuan": "Ich möchte einlösen",
    "ShengYu": "Verbleibend",
    "TuWenXiangQing": "Bild-Text Details",
    "YiDuiWan": "Vollständig eingelöst",
// integral-filter
    "FenLeiShaiXuan": "Kategoriefilter",
    "JiFenShaiXuan": "Punktefilter",
// integral-flow
    "JiFenShouRu": "Punkteeinnahmen",
    "JiFenZhiChu": "Punkteausgaben",
// integral-logistics
    "DingDanGenZong": "Bestellungsverfolgung",
    "WuLiuGongSi": "Logistikfirma",
    "WuLiuDanHao": "Logistiknummer",
// integral-order
    "DingDanLieBiao": "Bestellungsliste",
    "YiFaHuo": "Versendet",
    "JiFenDingDan": "Punktebestellung",
    "ChaKanWuLiu": "Logistik anzeigen",
// integral-order-create
    "LPSLBZ_QCX": "Geschenkmenge unzureichend, bitte erneut bezahlen",
    "JiFenBuZu": "Punkte unzureichend",
    "ZhiFuXinXi": "Zahlungsinformationen",
    "JiXuGuangGuang": "Weiter browsen",
    "QTXSHXX": "Bitte Lieferinformationen eingeben",
    "DuiHuanChengGong": "Einlösung erfolgreich",
    "LPDHQR": "Geschenkeinlösung bestätigen",
    "SCCKJ": "Marktreferenzpreis",
    "LiJiZhiFu": "Sofort bezahlen",
// integral-order-detail
    "DingDanXiangQing": "Bestellungsdetails",
    "DingDanZhuangTai": "Bestellungsstatus",
    "DingDanBianHao": "Bestellnummer",
    "DuiHuanShiJian": "Einlösungszeit",
    "ShouHuoXinXi": "Lieferinformationen",
    "HuaFeiJiFen": "Verwendete Punkte",
// integral-rule
    "QDZJF": "Anwesenheitspunktesammeln",
    "XDZJF": "Bestellungspunktesammeln",
    "DDWCHKHDYD": "Nach Abschluss der Bestellung erhält man Punkte entsprechend dem Bestellbetrag *",
    "1_MRQD_JL": "1. Täglich anwesend, Belohnung",
    "2_LXQD3T_EW": "2. 3 Tage in Folge anwesend, zusätzliche Belohnung",
    "3_LXQD7T_EW": "3. 7 Tage in Folge anwesend, zusätzliche Belohnung",
    "BeiDeJiFen": "fache Punkte",
    "DLZJF": "Anmeldungspunktesammeln",
    "MeiRiDengLu": "Täglich anmelden",
    "SC_JL": "Shop, Belohnung",
// integral-rule-detail
    "GuiZe": "Regeln",
// integral-sign
    "QianDaoYouLi": "Anwesenheit mit Belohnung",
    "QianDaoGuiZe": "Anwesenheitsregeln",
    "YLXQD": "Tage in Folge angemeldet",
    "QDCG_NYJLX": "Anwesenheit erfolgreich, Sie sind bereits",
    "QDCG_BCHD": "Anwesenheit erfolgreich, diese Zeit erhalten Sie",
    "QSRBZ": "Bitte Bemerkung eingeben",
    "DingDanZengPin": "Bestellungsgeschenk",
    "GuiGeBianHao": "Spezifikationsnummer",
    "GuiGe": "Spezifikation",
// combined-pay
    "CDDWXFK": "Diese Bestellung erfordert keine Zahlung",
    "YHYEBZ": "Benutzerguthaben unzureichend!",
    "ZFJEBNW0": "Zahlungsbetrag darf nicht 0 sein!",
    "ZFJEBNDYDD": "Zahlungsbetrag darf nicht größer als der ausstehende Zahlungsbetrag der Bestellung sein",
    "DFKJE": "Ausstehender Zahlungsbetrag",
    "FuKuanFangShi": "Zahlungsart",
    "FuJian": "Anhang",
    "ZHYFZ": "Konto kopiert",
    "GHSKZH": "Empfängerkonto wechseln",
    "SYXXZFQSCF": "Bei offline Zahlung bitte Zahlungs截图 hochladen, um die Finanzabteilung zur Bestätigung zu unterstützen!",
    "XXZF_BXXZS": "Offline Zahlung, Empfängerkonto muss ausgewählt werden",
    "DingDanZhiFu": "Bestellung bezahlen",
    "ZFFS_HDFK": "Zahlungsart: Nachnahme",
    "BCFKJE": "Dieser Zahlungsbetrag",
    "YuE": "Guthaben",
    "FuZhiZhangHao": "Konto kopieren",
    "WSZXCXZFPZ": "Keine Mini-Programm-Zahlungskonfiguration eingestellt",
    "XCXZFZHJY": "Mini-Programm-Zahlungskonto deaktiviert",
    "SRZFJE": "Zahlungsbetrag eingeben",
    "FuKuanZhangHu": "Zahlungskonto",
    "QueRenZhiFu": "Zahlung bestätigen",
    "ShaoHouZhiFu": "Später bezahlen",
// order
    "FKJLYTJ_DD": "Zahlungsrecord hinzugefügt, wartet auf Finanzprüfung",
    "JiXuGuang": "Weiter browsen",
    "BenCiFuKuan": "Diese Zahlung",
    "FuKuanChengGong": "Zahlung erfolgreich",
    "ZhiFuFangShi": "Zahlungsart",
    "ZhiFuDingDan": "Zahlungsbestellung",
// order-batch-pay
    "QXXZSXZFDD": "Bitte zuerst zu zahlende Bestellungen auswählen",
    "PiLiangFuKuan": "Stapelzahlung",
    "FuKuan": "Bezahlen",
    "'QuFuKuan'": "Zur Zahlung",
// order-create-result
    "YingFuJinE": "Zu zahlender Betrag",
    "XiaDanShiJian": "Bestellzeit",
// order-deliver
    "SFQRSH": "Bestätigen Sie den Empfang?",
    "DDQRSH_": "Bestellung empfangen bestätigen?",
    "DFHSP": "Ausstehende Versandprodukte",
    "ShangPinShuLiang": "Produktmenge",
    "ChuKuShiJian": "Auslagerungszeit",
    "FaHuoShiJian": "Versandzeit",
    "WuLiuBeiZhu": "Logistikbemerkung",
    "QueRenShouHuo": "Empfang bestätigen",
    "RYFK_QJSYG": "Wenn bereits bezahlt, kontaktieren Sie bitte zeitnah den Administrator",
    "QSRQXYY": "Bitte Grund für Stornierung eingeben",
    "H_DDJZDGB_QJKF": "später wird die Bestellung automatisch geschlossen, bitte bezahlen Sie schnellstmöglich",
    "TuiHuoQingKuang": "Retourenstatus",
    "DingDanZongE": "Gesamter Bestellbetrag",
    "DingDanBeiZhu": "Bestellungsbemerkung",
    "FaHuoQingKuang": "Versandstatus",
    "DingDanFuJian": "Bestellungsanhang",
    "ShenQingTuiHuo": "Retoure beantragen",
    "G1TDSHJL_QRS": "Insgesamt {num} ausstehende Empfangsrecords, Empfang bestätigen?",
    "DaiXiaDan": "Bestellung für Kunden",
    "DingDanHao": "Bestellnummer",
    "XiaDanFangShi": "Bestellart",
    "TuiHuoDan": "Retourenformular",
    "ShangPinZongE": "Gesamtproduktbetrag",
    "YunFei_ZongZhong": "Versandkosten (Gesamtgewicht",
    "SF_SPWS": "Steuer (Produkt ohne Steuer",
    "TePiJia": "Sonderpreis",
    "FuKuanQingKuang": "Zahlungsstatus",
    "TiaoJiLu": "Records",
    "ZaiLaiYiDan": "Noch eine Bestellung",
    "QDSCGDD_": "Bestellung wirklich löschen?",
    "YiQueRen": "Bestätigt",
    "YiShouHuo": "Empfangen",
    "DaiFuJinE": "Ausstehender Betrag",
    "YiFuJinE": "Bezogener Betrag",
    "ZanWuJiLu": "Keine Records",
    "SPMC_DDH": "Produktname / Bestellnummer",
    "FuKuanZhuangTai": "Zahlungsstatus",
    "FaHuoZhuangTai": "Versandstatus",
    "QiShiShiJian": "Startzeit",
    "ZhongZhiShiJian": "Endzeit",
// order-list
    "CaoZuoChengGong": "Operation erfolgreich",
    "ZBKGM": "Zurzeit nicht kaufbar",
    "DQDDSPYXJ": "Aktuelles Bestellprodukt ist offline genommen",
    "DQDDBFSPYXJ": "Teile der aktuellen Bestellprodukte sind offline genommen",
    "JTJSJSP": "Nur online gestellte Produkte hinzufügen",
    "DingHuoDan": "Bestellformular",
// order-log
    "DingDanRiZhi": "Bestellungsprotokoll",
// order-logistics
    "FuZhiChengGong": "Kopieren erfolgreich",
    "FuZhiShiBai": "Kopieren fehlgeschlagen",
    "FuZhi": "Kopieren",
    "BoDa": "Anrufen",
    "WCWLDHXX": "Keine Informationen zu dieser Logistiknummer",
// order-pay
    "ZFCS_QCXXD": "Zahlungszeitüberschreitung, bitte neu bestellen",
    "YQYYCKZF": "Vorschussguthaben-Zahlung aktiviert",
    "BNDYDFKJE": "Darf nicht größer als der ausstehende Zahlungsbetrag sein",
    "ZFJEBNWK": "Zahlungsbetrag darf nicht leer sein",
    "QXAPFK_FKH": "Bitte zuerst Zahlung arrangieren, nach Zahlung Screenshot hochladen, um die Finanzabteilung zur Bestätigung zu unterstützen",
    "DDTJCG_QJS": "Bestellung erfolgreich eingereicht, bitte zeitnah bezahlen",
    "QXZFKFS": "Bitte Zahlungsart auswählen",
    "SYYEZFH_HX": "Nach Zahlung aus Guthaben bleibt zu zahlen",
//
    "FuKuanJiLu": "Zahlungsrecords",
    "ZWFKJL": "Keine Zahlungsrecords",
    "FuKuanXiangQing": "Zahlungsdetails",
    "FuKuanJinE": "Zahlungsbetrag",
    "ZhiDan": "Erstellen",
    "ShenHe": "Prüfen",
    "ZuoFei": "Stornieren",
    "ZuoFeiYuanYin": "Grund für Stornierung",
    "GLDHD": "Verknüpftes Bestellformular",
    "HeXiaoJinE": "Abrechnungsbetrag",
    "HeXiaoZhuangTai": "Abrechnungsstatus",
    "DanJuZhuangTai": "Dokumentenstatus",
    "KeHuMingCheng": "Kundenname",
    "ZhangDanHao": "Rechnungsnummer",
    "ShouKuanZhangHao": "Empfängerkonto",
    "ShouKuanShiJian": "Empfangszeit",
    "FuKuanPingZheng": "Zahlungsnachweis",
    "GeFuJian": "Anhänge",
// order-statistics
    "DingDanTongJi": "Bestellungsstatistik",
    "DingHuo": "Bestellung",
    "Bi": "Stücke",
// order-statistics-detail
    "DDTJMX": "Bestellungsstatistikdetails",
    "AGGTJ": "Nach Spezifikation statistisch",
    "AFLTJ": "Nach Kategorie statistisch",
    "DDJE_Y": "Bestellbetrag/Yuan",
    "DHSP_Z": "Bestellprodukte/Arten",
    "DingHuoDan_Bi": "Bestellformulare/Stücke",
    "DingHuoShangPin": "Bestellprodukte",
    "JinE": "Betrag",
// refund-list
    "TuiHuo": "Retoure",
// refund-apply
    "THDHWBC_QD": "Retourenformular noch nicht gespeichert, sicher, dass Sie verlassen möchten?",
    "QSRSQTHJE": "Bitte beantragten Retourenbetrag eingeben",
    "QSRTHJE": "Bitte Retourenbetrag eingeben",
    "QSRBZXX": "Bitte Bemerkungsinformationen eingeben",
    "YingTuiJinE": "Rückerstattungsbetrag",
    "TJTHSQ": "Retourenanfrage einreichen",
    "QXXZDHQD": "Bitte zuerst Bestellliste auswählen",
    "DingHuoQingDan": "Bestellliste",
    "SQTHJE": "Beantragter Retourenbetrag",
    "DJXZSP": "Klicken Sie, um Produkte auszuwählen",
    "TuiHuoJinE": "Retourenbetrag",
// refund-detail
    "THDDXQ": "Retourenbestellungsdetails",
    "YiTuiHuo": "Zurückgesendet",
    "YiTuiKuan": "Rückerstattet",
    "THDZT": "Retourenformularstatus",
    "TuiHuoDanHao": "Retourennummer",
    "TuiHuoShiJian": "Retourenzeit",
    "TuiHuoCangKu": "Retourenlager",
    "THLXR": "Retourenkontaktperson",
    "TuiHuoQingDan": "Retourenliste",
    "TuiKuanZongE": "Gesamtrückerstattungsbetrag",
    "TuiKuanQingKuang": "Rückerstattungsstatus",
    "DaiTuiJinE": "Ausstehender Rückerstattungsbetrag",
    "YiTuiJinE": "Rückerstatteter Betrag",
// refund-product
    "SPMC_BH_GG": "Produktname / Nummer / Spezifikationsnummer / Barcode",
    "GZD1TJG": "Insgesamt 1 Ergebnis gefunden",
    "JiaRuQingDan": "Zur Liste hinzufügen",
// refund-result
    "ShenQingChengGong": "Antrag erfolgreich",
    "THDTJCG": "Retourenformular erfolgreich eingereicht",
    "ChaKanXiangQing": "Details anzeigen",
// goods-package-floor
    "HDWKS_WDZL": "Aktion noch nicht gestartet, kommen Sie später wieder",
    "HDYJS_XCZD": "Aktion beendet, nächstes Mal früher",
    "ZWSZBT": "Titel noch nicht eingestellt",
    "ChaKanGengDuo": "Mehr anzeigen",
// goods-promotion-floor
    "HCDZSJC": "Zeitdifferenz durch Cache verursacht",
    "DLCKCXJ": "Anmelden, um Promotionspreis zu sehen",
    "ZWSZCX": "Keine Promotion eingestellt",
    "JuKaiShi": "Bis zum Start",
    "Song": "Geben",
    "JuJieShu": "Bis zum Ende",
    "YiJieShu": "Beendet",
// search-floor
    "XiaoXi": "Nachrichten",
    "SaoMaXiaDan": "Scan und Bestellen",
// home-page-custom
    "WZLCSJ": "Unbekannte Etagendaten",
// jump-error
    "QXZYSDHAPP": "Bitte Yunshang Order APP herunterladen",
    "QMTYQYGLD": "Vollständige Unternehmensverwaltungsfunktionen erleben",
    "XZYSDHAPP": "Yunshang Order APP herunterladen",
    "HQGLDWZTY": "Vollständige Verwaltungsfunktionen erhalten",
    "JXTYDHD": "Weiter mit Bestellfunktionen",
// notice-detail
    "GongGaoXiangQing": "Ankündigungsdetails",
    "GongGaoFuJian": "Ankündigungsanhang",
// shop-error
    "NFWDYMBCZO": "Die von Ihnen besuchte Seite existiert nicht~",
    "KeNengYuanYin": "Mögliche Gründe",
    "1_ZDZLSRCWD": "1. Falsche Adresse in der Adressleiste eingegeben;",
    "2_DJLGQLJ": "2. Abgelaufenen Link geklickt.",
// shop-index
    "GuanLiDuan": "Verwaltungsseite",
    "ZhuCe": "Registrieren",
    "HYNTYYSDH": "Willkommen bei Yunshang Order",
    "TYZHSJHDQG": "Testkontodaten werden regelmäßig aktualisiert, geben Sie keine wichtigen Informationen ein",
    "TYZHZDNRSJ": "Inhalte im Testkonto sind fiktiv, geben Sie keine wichtigen Informationen ein",
    "ZHZCCG": "Konto erfolgreich registriert",
    "DengLuZhangHao": "Anmeldekonto",
    "CSMMW": "Initialpasswort ist",
    "GNFYHQL": "Es wurden Gutscheine für Sie versendet",
    "Man1YuanKeYong": "Ab {num} Yuan anwendbar",
    "LQH1TNKY": "Nach Gutschein领取 innerhalb {day} Tagen anwendbar",
    "YiJianLingQu": "Ein-Klick领取",
    "GXNHD1ZYHQ": "Glückwunsch, Sie erhalten 1 Gutschein",
    "Gong1Yuan": "Insgesamt 1 Yuan",
    "LiJiShiYong": "Sofort verwenden",
// shop-login
    "NHWDL": "Sie sind nicht angemeldet",
// shop-notice
    "ShangChengGongGao": "Shopankündigungen",
    "ZanWuGongGao": "Keine Ankündigungen",
    "1GeFuJian": "{num} Anhänge",
// deposit-detail
    "KouKuan": "Abzug",
    "ChongZhi_Kuan": "Aufladen",
    "KouKuanZuoFei": "Abzug storniert",
    "ChongZhiZuoFei": "Aufladen storniert",
    "ZhangHuMingXi": "Kontodetails",
    "ZhangHuYuE": "Kontoguthaben",
    "LiJiChongZhi": "Sofort aufladen",
// deposit-recharge
    "CZJEBNXY1Y": "Aufladebetrag darf nicht weniger als 1 Yuan sein",
    "QSRZQDSZ": "Bitte richtigen Wert eingeben",
    "ZDYJE": "Benutzerdefinierter Betrag",
    "ZWKTXSCZGN": "Online-Aufladen derzeit nicht verfügbar",
    "ShiFuJinE": "Tatsächlicher Zahlungsbetrag",
    "ZhangHuChongZhi": "Konto aufladen",
    "QXZCZJE": "Bitte Aufladebetrag auswählen",
    "QSRCZJE": "Bitte Aufladebetrag eingeben",
    "QLXNDZSYWY": "Bitte Ihren persönlichen Verkäufer zur Aufladung kontaktieren",
    "ShouJia": "Verkaufspreis",
    "YiShouQing": "Ausverkauft",
    "ChongZhiJinE": "Aufladebetrag",
    "QueRenFuKuan": "Zahlung bestätigen",
// deposit-recharge-result
    "QSDDID": "Bestell-ID fehlt",
    "ChongZhiChengGong": "Aufladen erfolgreich",
    "ChongZhiShiBai": "Aufladen fehlgeschlagen",
    "CLZ_QSH...": "Verarbeitet, bitte warten...",
    "ChongZhiFangShi": "Aufladeart",
    "ChongZhiShiJian": "Aufladezeit",
    "JYLSH": "Transaktionsnummer",
    "FanHuiShangCheng": "Zurück zum Shop",
// recharge-online
    "ZFSB_QCS": "Zahlung fehlgeschlagen, bitte erneut versuchen",
    "ZFYQX": "Zahlung abgebrochen",
    "ZFYC_QCS": "Zahlungsfehler, bitte erneut versuchen",
// user
    "LingQuanZhongXin": "Gutscheinzentrum",
    "WeiShiYong": "Nicht verwendet",
    "YiShiYong": "Verwendet",
    "ZWYHQ": "Keine Gutscheine",
// keep-list
    "YiGouMai": "Gekauft",
    "ChangYongQingDan": "Regelmäßige Liste",
    "WoDeShouCang": "Meine Sammlung",
    "QuGouWuChe": "Zum Warenkorb",
    "GeShangPin": "Produkte",
// login
    "YunShangDingHuo": "Yunshang Order",
    "QSRZH": "Bitte Konto eingeben!",
    "QSRMM": "Bitte Passwort eingeben!",
    "QSRDLZH": "Bitte Anmeldekonto eingeben",
    "JiZhuMiMa": "Passwort merken",
    "WangJiMiMa": "Passwort vergessen?",
    "DengLu": "Anmelden",
    "DLZHBCZ_QL": "Anmeldekonto existiert nicht, bitte Administrator zur Aktivierung kontaktieren",
    "GQYZHSBJY_": "Dieses Unternehmenskonto ist deaktiviert, bitte Yunshang Order kontaktieren",
    "GQYZHSYQJS_": "Testphase des Unternehmenskontos abgelaufen, bitte Yunshang Order kontaktieren",
    "GQYZHYGQL_": "Dieses Unternehmenskonto ist abgelaufen, Erneuerung erforderlich, bitte Yunshang Order kontaktieren",
    "LiJiTiYan": "Sofort ausprobieren",
// my-collect
    "YiChuChengGong": "Entfernen erfolgreich",
    "QueHuo": "Nicht auf Lager",
    "YCSCJ": "Aus Sammlung entfernen",
// order-message
    "SheZhiChengGong": "Einstellung erfolgreich",
    "ZWWDXX": "Keine ungelesenen Nachrichten",
    "QuanBuYiDu": "Alle als gelesen markieren",
    "DingDanXiaoXi": "Bestellungsnachrichten",
    "YiQiang": "Erhalten",
    "LiJiLingQu": "Sofort领取",
    "LingQuanHou": "Nach Gutschein领取",
    "TianNeiKeYong": "innerhalb Tagen anwendbar",
    "QSRSJH": "Bitte Handynummer eingeben",
    "QSRYZM": "Bitte Bestätigungscode eingeben",
    "QSRXMM": "Bitte neues Passwort eingeben",
    "QSRZQSJGS": "Bitte richtiges Telefonformat eingeben",
    "ChongZhiMiMa": "Passwort zurücksetzen",
    "QSRNDSJHM": "Bitte Ihre Handynummer eingeben",
    "QSRDXYZ": "Bitte SMS-Bestätigungscode eingeben",
    "HQYZM": "Bestätigungscode abrufen",
    "HKCXHQ": "erneut abrufen nach",
    "QSR6_20WSZHZ": "Bitte Passwort mit 6-20 Ziffern oder Buchstaben eingeben",
// share-setting
    "QSRSPJGBL": "Bitte Produktpreisprozentsatz eingeben",
    "SPJGBLBXDY": "Produktpreisprozentsatz muss größer oder gleich 100 und kleiner 999.99 sein",
    "DPMCZBZCTS": "Shopname unterstützt derzeit keine Sonderzeichen",
    "LXRZBZCTSF": "Kontaktperson unterstützt derzeit keine Sonderzeichen",
    "LXFSZBZCTS": "Kontaktmethode unterstützt derzeit keine Sonderzeichen",
    "LXDZZBZCTS": "Kontaktadresse unterstützt derzeit keine Sonderzeichen",
    "DPJJZBZCTS": "Shopbeschreibung unterstützt derzeit keine Sonderzeichen",
    "QSRDPJJ_ZD": "Bitte Shopbeschreibung eingeben, max. 50 Zeichen",
    "FenXiangSheZhi": "Freigabeeinstellungen",
    "NDWSCSPJG": "Produktpreis Ihres Mini-Shops",
    "NDDHJ_": "Ihr Bestellpreis ×",
    "LXXX_KBJ_": "Kontaktinformationen (bearbeitbar)",
    "DianPuMingCheng": "Shopname",
    "JianJie": "Beschreibung",
    "QSRDPMC": "Bitte Shopname eingeben",
    "LianXiRen": "Kontaktperson",
    "QSRLXR": "Bitte Kontaktperson eingeben",
    "LianXiFangShi": "Kontaktmethode",
    "QSRLXFS": "Bitte Kontaktmethode eingeben",
    "LianXiDiZhi": "Kontaktadresse",
    "QSRLXDZ": "Bitte Kontaktadresse eingeben",
// user
    "WoDeDingDan": "Meine Bestellungen",
    "ZuiJinLiuLan": "Kürzlich angesehen",
    "ShouCangShangPin": "Produkte in Sammlung",
    "BDYYZH_ZC": "Bestehendes Konto binden | Neues Konto registrieren",
    "DL_ZC": "Anmelden | Registrieren",
    "BangDingShouJi": "Handy binden",
    "TS_BDSJHM_": "Hinweis: Binden Sie Ihre Handynummer, um das Konto sicherer zu machen!",
    "ChaKanQuanBu": "Alle anzeigen",
    "ShouHuoDiZhi": "Lieferadresse",
    "LianXiWoMen": "Kontaktieren Sie uns",
    "SheZhi": "Einstellungen",
    "QuQianDao": "Zur Anwesenheit",
    "JiFenShangCheng": "Punkte-Shop",
    "TuiGuangShangPin": "Produkte bewerben",
    "QuChaKan": "Zur Anzeige",
    "JiFenHuanLi": "Punkte in Geschenke umwandeln",
    "DYSPBQ": "Produktetikett drucken",
// user-about
    "GYYSDH": "Über Yunshang Order",
    "YQHYSMEWM_": "Laden Sie Freunde ein, den QR-Code zu scannen und direkt herunterzuladen",
    "DangQianBanBen": "Aktuelle Version",
// user-address
    "ZWSHDZ": "Keine Lieferadresse",
    "WoDeDiZhi": "Meine Adressen",
    "ZhiNengShiBie": "Intelligente Erkennung",
    "ZTDZXXKZNS": "Adressinformationen einfügen, um Name, Telefon und Adresse intelligent zu erkennen",
    "MoRen": "Standard",
    "QRSCDZ": "Adresse wirklich löschen?",
    "SHRXM": "Empfängername",
    "SJHMHGDDHZ": "Mindestens eine Handynummer oder Festnetznummer eingeben",
    "QSRSHRXM": "Bitte Empfängername eingeben",
    "ShouJiHaoMa": "Handynummer",
    "GuDingDianHua": "Festnetznummer",
    "QSRGDDH": "Bitte Festnetznummer eingeben",
    "SuoZaiDiQu": "Region",
    "QSRSZDQ": "Bitte Region eingeben",
    "QSRXXDZ": "Bitte detaillierte Adresse eingeben!",
    "QSRZQDSJHM": "Bitte richtige Handynummer eingeben",
    "QSRZQDGDDH": "Bitte richtige Festnetznummer eingeben",
    "XiangXiDiZhi": "Detaillierte Adresse",
    "MoRenDiZhi": "Standardadresse",
    "SWMRDZ": "Als Standardadresse festlegen",
    "BCBSY": "Speichern und verwenden",
// user-bing-one
    "QSRSJHM": "Bitte Handynummer eingeben",
    "GYHYZC": "Dieser Benutzer ist bereits registriert",
    "GSJHMYJZCG": "Diese Handynummer ist bereits registriert",
    "QZJDLJK": "Bitte direkt anmelden",
    "QuDengLu": "Zum Login",
    "BDHKYTGSJH": "Nach dem Binden können Sie über die Handynummer anmelden, um das Passwort wiederzuerhalten und die Kontosicherheit zu verbessern",
    "_BDHKYTGSJ": "*Nach dem Binden können Sie über die Handynummer anmelden, um das Passwort wiederzuerhalten und die Kontosicherheit zu verbessern",
    "QSRSJYZM": "Bitte Handy-Bestätigungscode eingeben",
    "BDXSJ": "Neues Handy binden",
    "DXYZM": "SMS-Bestätigungscode",
    "XiaYiBu": "Weiter",
    "TGCBZ": "Diesen Schritt überspringen",
// user-bing-two
    "DBDSJHMBCZ": "Zu bindende Handynummer existiert nicht!",
    "QSRDLMM": "Bitte Anmeldepasswort eingeben!",
    "_GSJHMYBDY": "*Diese Handynummer ist bereits an ein Yunshang Order-Konto gebunden. Verifizieren Sie das Handyanmeldepasswort, um es an das aktuelle Konto zu binden",
    "DQZHMMJTBW": "Das aktuelle Kontopasswort wird synchronisiert als Handyanmeldepasswort",
    "DangQianZhangHao": "Aktuelles Konto",
//
    "QDYJZ": "Sind Sie sicher, dass Sie diese",
    "JSPSCM": "Produkte löschen möchten?",
    "ShanChuChengGong": "Löschung erfolgreich!",
// user-info
    "SJGSCW": "Falsches Telefonformat",
    "YXGSCW": "Falsches E-Mail-Format",
    "WoDeZhangHao": "Mein Konto",
    "YouXiang": "E-Mail",
    "ShouJi": "Handy",
    "XingMing": "Name",
    "XiuGaiTouXiang": "Avatar bearbeiten",
    "JiBenXinXi": "Grundinformationen",
    "ZhangHaoAnQuan": "Kontosicherheit",
    "XiuGaiMiMa": "Passwort ändern",
    "DianJiBangDing": "Klicken Sie zum Binden",
    "RYDSHTY_QL": "Wenn verloren oder deaktiviert, ersetzen Sie es sofort, um Kontodiebstahl zu verhindern",
    "WBZNDZHAQ_": "Zur Sicherstellung Ihrer Kontosicherheit, bitte Handy binden",
    "QSRNDXM": "Bitte Ihren Namen eingeben",
    "QSRNDDH": "Bitte Ihre Telefonnummer eingeben",
    "QSRNDYX": "Bitte E-Mail eingeben",
// user-setting
    "QCHCHXCXDL": "Nach Cache-Löschung neu anmelden",
    "QingChuHuanCun": "Cache löschen",
    "QDYQCHCM": "Sind Sie sicher, dass Sie den Cache löschen möchten?",
    "TuiChuDengLu": "Abmelden",
    "QieHuanZhangHao": "Konto wechseln",
// user-supplier
    "LianXi": "Kontakt",
    "GongSiDianHua": "Firmen Telefon",
    "DiZhi": "Adresse",
// vouchers-detail
    "DJQMX": "Gutscheindetails",
// vouchers-list
    "BuKeYong": "Unverwendbar",
    "KeYong": "Verwendbar",
    "ZWDJQ": "Keine Gutscheine",
    "ZongEDu": "Gesamtwert",
    "FaFangShiJian": "Ausgabedatum",
    "EDYYW": "Guthaben aufgebraucht",
    "QBSPKY": "Für alle Produkte verwendbar",
// vouchers-select-list
    "WDDJQ": "Meine Gutscheine",
    "KYDJQ": "Verwendbare Gutscheine",
    "DJQKDK": "Gutschein kann absetzen",
    "CKKYSP": "Verwendbare Produkte anzeigen",
    "BKYDJQ": "Unverwendbare Gutscheine",
    "BKYYY_ZWFH": "Grund für Unverwendbarkeit: Keine passenden Produkte",
// goods-detail
    "DQSPWSCGGT": "Aktuelles Produkt hat keine Spezifikationsbilder hochgeladen, Beleuchtungskonfiguration nicht unterstützt!",
    "BoFangShiPin": "Video abspielen",
    "Gong1GeGuiGe": "Insgesamt {num} Spezifikationen",
    "YiXuanGuiGe": "Ausgewählte Spezifikation",
    "XuanGuiGe": "Spezifikation auswählen",
    "LingQuan": "Gutschein领取",
    "1ZhongCuXiao": "1 Promotion",
    "1ZhangKeYong": "1 verwendbar",
    "ZuiGaoKeSheng": "Maximal sparen",
    "ShangPinTaoCan": "Produktpaket",
    "Gong1GeTaoCan": "Insgesamt 1 Paket",
    "ShangPinCanShu": "Produktparameter",
    "ZhanKai": "Ausklappen",
    "YiShouCang": "In Sammlung",
    "ShouCang": "Zur Sammlung hinzufügen",
    "KeFu": "Kundenservice",
    "XiangQing": "Details",
    "TuiJian": "Empfohlen",
    "BianHao": "Nummer",
    "ShangPinXinXi": "Produktinformationen",
    "KLYHQ": "Verfügbare Gutscheine",
    "KuCunBuZu": "Lagerbestand unzureichend",
    "DuoGuiGe": "Mehrere Spezifikationen",
    "YiShou": "Verkauft",
    "SWBHZ_YS": "Nachbestellung läuft, verkauft",
    "CuXiaoShangPin": "Promotionsprodukt",
// goods-search
    "NHWSRSSNR": "Sie haben noch keine Suchbegriffe eingegeben",
    "SouSuo": "Suchen",
    "SSY1XGDSP": "Nach {searchKey}相关的Produkten suchen",
    "Yue1GeShangPin": "Ungefähr {num} Produkte",
    "ZuiJinSouSuo": "Kürzlich gesucht",
    "QingChu": "Löschen",
    "ZWSSJL": "Keine Suchhistorie",
// goods-property
    "ZGJGBNDYZD": "Höchster Preis darf nicht niedriger als der niedrigste Preis sein",
    "ShangPinBiaoQian": "Produktetikett",
    "BuGaoYu1": "Nicht höher als 1",
    "BuDiYu1": "Nicht niedriger als 1",
    "FengGe": "Stil",
// goods-promotion-list
    "JiJiangKaiShi": "Gleich losgehen",
    "QuanBuCuXiao": "Alle Promotionen",
// goods-package-list
    "Gong1JianShangPin": "Insgesamt 1 Produkt",
    "Sheng": "Sparen",
// goods-package-detail
    "GTCZGWCZDS": "Die Anzahl des Pakets im Warenkorb hat das Limit erreicht, kann nicht hinzugefügt werden",
    "GTCKCBZ_BK": "Paketlagerbestand unzureichend, kann nicht in Warenkorb hinzugefügt werden",
    "JinSheng1Tao": "Nur 1 Set übrig",
    "XianGou1Tao": "Max. 1 Set kaufen",
    "TaoCanXiangQing": "Paketdetails",
    "DanMaiJia": "Einzelpreis",
    "TaoCanJia": "Paketpreis",
    "HDYJS": "Aktion beendet",
// goods-message
    "WDL_QXDL": "Nicht angemeldet, bitte zuerst anmelden",
// goods-list-label
    "XinPinShangShi": "Neuheiten",
    "WDLZH_ZWCX": "Nicht angemeldet, keine Promotionen!",
    "YiXiaShangPin": "Folgende Produkte",
// goods-list
    "1ZhongGuiGe": "1 Spezifikation",
    "YouKuCun": "Auf Lager",
// goods-filter
    "BuGaoYu": "Nicht höher als",
    "BuDiYu": "Nicht niedriger als",
    "CuXiao": "Promotion",
    "ZDYXXZ3G": "Maximal 3 auswählen",
    "GouMai": "Kaufen",
    "Gong1Jian": "Insgesamt {num} Stück",
// 已订货商品
    "DLHCKJG": "Nach Anmeldung Preis anzeigen",
    "M1JZ1J": "Bei {num} Stück {presentNum} Stück geschenkt",
    "CZPF_ZZCXC": "Zu频繁操作, versuche erneut",
    "XSZJJXZ": "Begrenzte Zeit Sofortrabatt läuft",
    "YXSPM1YZ1J_": "Folgende Produkte {str}, im Warenkorb bezahlen, um Vorteile zu erhalten!",
    "TiaoXingMa": "Barcode",
    "XiangGuanTuiJian": "Verwandte Empfehlungen",
    "YSSPBKJRGW": "Vorkaufsprodukte können nicht in den Warenkorb hinzugefügt werden, nicht vorverkaufte Produkte wurden hinzugefügt!",
    "YSSPBKLJGM": "Vorkaufsprodukte können nicht sofort gekauft werden, entfernen Sie vorverkaufte Produkte und kaufen Sie erneut!",
    "SPSLYW": "Produktmenge falsch",
    "ShangPin1QiShou": "Produkt {num} abverkaufen",
    "SPDGSLBNCG": "Produktbestellmenge darf nicht über {num} hinausgehen",
    "QRYCXZSP": "Ausgewählte Produkte wirklich entfernen",
    "QRYCSYSXSP": "Alle ungültigen Produkte wirklich entfernen",
    "QRYCXZSXSP": "Ausgewählte ungültige Produkte wirklich entfernen",
    "M1YZ1J": "Bei {num} Yuan {presentNum} Stück geschenkt",
    "M1YJ1Y": "Bei {price} Yuan {money} Yuan rabattiert",
    "M1J1": "Bei {price} {money} rabattiert",
    "M1YD1Z": "Bei {price} Yuan {money} % Rabatt",
    "DDM1YHZ": "Bei Bestellwert {price} Yuan erhalten",
    "YiHuoZeng": "Bereits erhalten",
    "ZG1YLXM1YZ1": "Noch {price} Yuan kaufen, um {str} zu erhalten",
    "ZG1JLXM1JZ1": "Noch {num} Stück kaufen, um {str} zu erhalten",
    "QCSXSP": "Ungültige Produkte löschen",
    "YiXuanShangPin": "Ausgewählte Produkte",
    "QuJieSuan": "Zur Kasse",
    "ShiXiaoShangPin": "Ungültige Produkte",
    "DingDanGuanLi": "Bestellungsverwaltung",
    "ZhuangTai": "Status",
    "ShangPinChuKu": "Produktauslagerung",
    "DengDaiShouHuo": "Warten auf Empfang",
    "PeiSongXinXi": "Lieferinformationen",
    "FuKuanXinXi": "Zahlungsinformationen",
    "GDFKJL": "Mehr Zahlungsrecords",
    "WuLiuFuJian": "Logistikanhang",
    "ZanWuFuJian": "Keine Anhänge",
    "YiFa": "Gesendet",
    "YingFuZongE": "Gesamter zu zahlender Betrag",
    "FuKuanShiJian": "Zahlungszeit",
    "ZhangHuHaoMa": "Kontonummer",
    "KeYongYuE": "Verwendbares Guthaben",
    "TianJiaChengGong": "Hinzugefügt erfolgreich",
    "ShanChuDiZhi": "Adresse löschen",
    "QXZSHDZ": "Bitte Lieferadresse auswählen",
    "YiHuoZengPin": "Bereits erhaltene Geschenke",
    "YiYouHui1Yuan": "Bereits {money} Yuan rabattiert",
    "QWSFPXX": "Bitte Rechnungsinformationen vervollständigen",
    "1ZSP": "{num} Produktarten",
    "Gong": "Insgesamt",
    "Jian": "Stücke",
    "ShangPinJinE": "Produktbetrag",
    "YunFeiDaoFu": "Nachnahme",
    "QSRZQDSHRX": "Bitte richtigen Empfängernamen eingeben",
    "QSRZQDXXDZ": "Bitte richtige detaillierte Adresse eingeben",
    "DBQ_MYZDDY": "Entschuldigung, keine entsprechende Seite gefunden",
    "ShouHuoChengGong": "Empfang erfolgreich",
    "Hi_HuanYingNin": "Hi, willkommen",
    "YiFaEWuLiu": "E-Logistik gesendet",
    "NinDeDingDan": "Ihre Bestellung",
    "ZBNBHBQ": "kann keine Emojis enthalten",
    "XMBNWK": "Name darf nicht leer sein",
    "XiTongSheZhi": "Systemeinstellungen",
    "ZhangHaoXinXi": "Kontoinformationen",
    "QingShuRuXingMing": "Bitte Namen eingeben",
    "QWSZL_JZYG": "Bitte Profil vervollständigen, um bessere Dienstleistungen zu erhalten",
    "QSRZQDYXGS": "Bitte richtiges E-Mail-Format eingeben",
    "QTXZQDCWXX": "Bitte richtige Finanzinformationen eingeben, damit Ihre Partner Ihnen Rechnungen ausstellen können",
    "GXSHDZCG": "Lieferadresse erfolgreich aktualisiert",
    "BCSHDZCG": "Lieferadresse erfolgreich gespeichert",
    "XinZengDiZhi": "Neue Adresse hinzufügen",
    "QXZYQXSCDS": "Bitte auszuwählende Sammlungsprodukte auswählen",
    "QuXiaoShouCang": "Sammlung aufheben",
    "XuanZeGuiGe": "Spezifikation auswählen",
    "CaiWuGuanLi": "Finanzverwaltung",
    "DuiZhangMingXi": "Kontrollbuchdetails",
    "QSRLWJL_JE": "Bitte Kontaktsaufzeichnungen/Betrag eingeben",
    "YiGouMai1Ci": "Bereits {count} Mal gekauft",
    "6_1GouMai": "{time} gekauft",
    "TZGGXQ": "Benachrichtigungsdetails",
    "ZYXSCSP": "Nur Videos hochladen erlaubt",
    "SCSPDXBYXC": "Größe des hochgeladenen Videos darf {size} nicht überschreiten",
    "YDHSP": "Bestellte Produkte",
    "ShangPinPinPai": "Produktmarke",
    "ShangPinLieBiao": "Produktliste",
    "LingShouJia": "Verkaufspreis",
    "YouHuiJia": "Rabattpreis",
    "LiJiGouMai": "Sofort kaufen",
    "ZhuTu": "Hauptbild",
    "WuXianZhi": "Keine Begrenzung",
    "XiaoJi": "Zwischensumme",
    "SCXZSP": "Ausgewählte Produkte löschen",
    "QSRDDH": "Bitte Bestellnummer eingeben",
        "QSRDDH_SPMC": "Bitte Bestellnummer/Produktname eingeben",
    "CaoZuo": "Operation",
    "WuLiuXinXi": "Logistikinformationen",
    "CaoZuoLeiXing": "Operationstyp",
    "CaoZuoRiZhi": "Operationsprotokoll",
    "CaoZuoShiJian": "Operationszeit",
    "ZhangHuMingCheng": "Kontoname",
    "KaiHuYinHang": "Bank",
    "DDTJCG_XZZC": "Bestellung erfolgreich eingereicht, nur noch ein letzter Schritt",
    "ZhiFuJinE": "Zahlungsbetrag",
    "DZFJE": "Ausstehender Zahlungsbetrag",
    "QTXYXSMB": "Einige Anmerkungen eingeben",
    "XZSKYHZH": "Empfängerbankkonto auswählen",
    "TiShi": "Hinweis",
    "NHY1GDDGJ1Y": "Sie haben noch {num} Bestellungen mit insgesamt {money} Yuan offen",
    "QKJQHCKJXX": "Nach Zahlung der offenen Rechnungen können Sie weiter bestellen",
    "HDDDXX": "Bestellinformationen prüfen",
    "BJSHDZ": "Lieferadresse bearbeiten",
    "TongZhiGongGao": "Benachrichtigungen und Ankündigungen",
    "YinHangZhangHao": "Bankkonto",
    "XiuGaiShouJi": "Handynummer bearbeiten",
    "LXRXX": "Kontaktpersoneninformationen",
    "GSCWXX": "Firmenfinanzinformationen",
    "QSRKHYHMCJ": "Bitte Namen der Bank und Zweigniederlassung eingeben",
    "QSRYHZH": "Bitte Bankkonto eingeben",
    "PiLiangCaoZuo": "Stapelverarbeitung",
    "GouMaiJiLu": "Kaufrecords",
    "TongZhiBiaoTi": "Benachrichtigungstitel",
    "FaBuShiJian": "Veröffentlichungszeit",
    "XiaoXiLeiXing": "Nachrichtentyp",
    "XiaoXiNeiRong": "Nachrichteninhalt",
    "JieShouShiJian": "Empfangszeit",
    "QuanBuPinPai": "Alle Marken",
    "WXSYS_DHGBJ": "WeChat scannen, Bestellen bequemer",
    "GZWXGZH": "WeChat-Offizielle Konto folgen",
    "FuWuReXian": "Service-Hotline",
    "SouSuoLiShi": "Suchgeschichte",
    "QuanBuShanChu": "Alle löschen",
    "NH_HYLDYSDH": "Hallo, willkommen bei {company}!",
    "ZSJDH": "Auf dem Handy bestellen",
    "SYS_GZWXGZH": "Scannen Sie, um dem WeChat-Offiziellen Konto zu folgen",
    "GuanZhuWoMen": "Folgen Sie uns",
    "QBSPFL": "Alle Produktkategorien",
    "QuPeiDeng": "Zur Beleuchtungskonfiguration",
    "KuanXiang": "Betrag",
    "QSRSPMC_GG_": "Bitte Produktname/Spezifikation/Nummer/Erster Buchstabe eingeben",
    "NH_HYLDYSD": "Hallo, willkommen im Yunshang Order Shop!",
    "ReXiao": "Beliebt",
    "20Tiao_Ye": "20 pro Seite",
    "ShiChangJia_": "Marktpreis:",
    "_134.10Qi": "Ab S/ 134.10",
    "HJ_BHYF": "Gesamt (ohne Versandkosten):",
    "QDSCXZSP_": "Ausgewählte Produkte wirklich löschen?",
    "QDQCXJSP_": "Offline genommene Produkte wirklich löschen?",
    "DDTJCG_XZZ": "Bestellung erfolgreich eingereicht, nur noch ein letzter Schritt!",
    "XuanZeZhangHu": "Konto auswählen",
    "DaiZhiFu": "Ausstehend bezahlen",
    "CaiGouDingDan": "Einkaufsbestellung",
    "DingDanXinXi": "Bestellinformationen",
    "TuiChu": "Beenden",
    "KaiHuMingCheng": "Kontoinhaber",
    "QSRKHMC": "Bitte Kontoinhaber eingeben",
    "_QTXZQDCWX": " (Bitte richtige Finanzinformationen eingeben, damit Ihre Partner Ihnen Rechnungen ausstellen können)",
    "ShouHuoRen": "Empfänger",
    "SWMRSHDZ": "Als Standardlieferadresse festlegen",
    "TianJiaDiZhi": "Adresse hinzufügen",
    "Gong4GeGuiGe": "Insgesamt 4 Spezifikationen",
    "Zhi": "Nur",
    "Kuai": "Stück",
    "Tou": "Kopf",
    "Xiang": "Kiste",
    "Ping": "Flasche",
    "KaiShiRiQi": "Startdatum",
    "JieShuRiQi": "Enddatum",
    "YiXuan": "Ausgewählt",
    "ZhiFuZhuangTai": "Zahlungsstatus",
    "QDLCKJG": "Anmelden, um Preis zu sehen",
    "YZMBZQ": "Bestätigungscode falsch",
    "ZhiFuJiLu": "Zahlungsrecords",
    "ShangPinMingCheng": "Produktname",
    "DingGouShuLiang": "Bestellmenge",
    "TuiHuoShuLiang": "Retourenmenge",
    "QSRTHNR": "Bitte Retoureninhalte eingeben",
    "SCTHSM": "Retourenbeschreibung hochladen",
    "ShenQingShiJian": "Antragszeit",
    "ShenQingJinE": "Antragsbetrag",
    "TuiHuoYuanYin": "Grund für Retoure",
    "TuiHuoShuoMing": "Retourenbeschreibung",
    "TuiDanHao": "Retourennummer",
    "SXCZ_XDCG": "Kredit ausreichend, Bestellung erfolgreich",
    "SXEDBZ_FKHFH": "Kreditlimit unzureichend, nach Zahlung versenden",
    "CGJKZQ_FKFH": "Über Kreditfrist, nach Zahlung versenden",
    "DDTJCG_XZZCZHYB": "Bestellung erfolgreich eingereicht, nur noch ein letzter Schritt!",
    "QNZ_NWCFK_FZ": "Bitte bezahlen Sie innerhalb {time}, sonst wird die Bestellung automatisch storniert.",
    "MianFeiLing": "Kostenlos abholen",
    "M_KMFLQ_HQ": "Ab {target} Yuan kostenlos erhältlich, noch {short} Yuan fehlend",
    "YHDMFSP": "Kostenlose Produkte erhalten",
    "JRMFL": "Heute kostenlos abholen",
    "LingGuangLe": "Ausverkauft",
    "KeLingQu": "Abholbar",
    "QSRZFJE": "Bitte Zahlungsbetrag eingeben",
    "QNJKFK_WMJKWNCL": "Bitte bezahlen Sie so schnell wie möglich, wir verarbeiten Ihre Bestellung umgehend!",
    "XianXiaTiYanGuan": "Offline-Erlebniszentrum",
    "QingXuanZheSheng": "Bitte Provinz auswählen",
    "QingXuanZheShi": "Bitte Stadt auswählen",
    "ZhanGuanDiZhi": "Ausstellungsort",
    "YingYeShiJian": "Öffnungszeiten",
    "ZhanGuanDianHua": "Ausstellungsnummer",
    "FenXiang": "Teilen",
    "TiYanGuanJieShao": "Erlebniszentrum-Beschreibung",
    "DPYDY_QSHX": "Shop ist geschlossen, bitte später bestellen",
    "DaYangShiJian": "Schließzeit",
    "IMEI": "Seriennummer",
    "FanKuanYuE": "Rückerstattungsguthaben",
    "FanKuanZhiFu": "Rückerstattungszahlung",
    "YiShengZhiFu": "Yisheng Zahlung",
    "JiongDongShouYinTai": "JD Kasse",
    "FKYEBZ": "Rückerstattungsguthaben unzureichend",
    "FanKuanZhangHu": "Rückerstattungskonto",
    "HaiXuZhiFu": "Noch zu zahlen {price}",
    "FaPiaoMingXi": "Rechnungsdetails",
    "FaPiaoZhuShou": "Rechnungsassistent",
    "WoDeFaPiao": "Meine Rechnungen",
    "FaPiaoXiangQing": "Rechnungsdetails",
    "KaiPiaoShiJian": "Rechnungsdatum",
    "DaiKaiFaPiao": "Ausstehende Rechnungen",
    "DKFPJE": "Ausstehender Rechnungsbetrag",
    "KaiPiaoJinE": "Rechnungsbetrag",
    "GuanLianDanHao": "Verknüpfte Nummer",
    "ChuangJianShiJian": "Erstellungszeit",
    "ZhiFuPingZheng": "Zahlungsnachweis",
    "QSRZQNR": "Bitte richtige Inhalte eingeben",
    "QSRTDH_SPMC": "Bitte Retourennummer/Produktname eingeben",
    "ShangPinRuKu": "Produkteinlagerung",
    "TuiKuanChuLi": "Rückerstattungsverarbeitung",
    "YuanDingDanHao": "Ursprüngliche Bestellnummer",
    "TuiHuoXinXi": "Retoureninformationen",
    "TuiKuanXinXi": "Rückerstattungsinformationen",
    "TuiKuanZhuangTai": "Rückerstattungsstatus",
    "ZWTKJL": "Keine Rückerstattungsrecords",
    "GDTKJL": "Mehr Rückerstattungsrecords",
    "DDDKFQRBJQSH": "Bestellung wartet auf Kundenservice-Bestätigung, bitte warten",
    "BNSRDYHDTSZF": "Anführungszeichen und andere Sonderzeichen dürfen nicht eingegeben werden",
    "THSLBNWK": "Retourenmenge darf nicht leer sein",
    "BZBNBHBQ": "Bemerkungen dürfen keine Emojis enthalten",
    "THSLBKDYKTHSL": "Retourenmenge größer als zulässige Retourenmenge",
    "DDM_YZ_J": "Bestellung ab {target} Yuan {number} Stück geschenkt",
    "M_JZ_J": "Ab {target} Stück {number} Stück geschenkt",
    "M_JJZ_Y": "Ab {target} Stück reduziert auf {money} Yuan",
    "YDHJJZ_Y": "Ursprünglicher Bestellpreis reduziert auf {price} Yuan",
    "M_JD_Z": "Ab {number} Stück {percent} % Rabatt",
    "YDHJD_Z": "Ursprünglicher Bestellpreis mit {percent} % Rabatt",
    // Mercado Pago支付
    "WDSYT": "Meine Kasse",
    "ZZSYMPSMJY": "Verwenden Sie derzeit Mercado Pago für Scan-Zahlung",
    "SKF": "Empfänger",
    "SYSFK": "Scan zum Bezahlen",
    "DDXQ": "Bestellungsdetails",
    "YUAN": "Yuan",
    // 优惠券
    "GXNHQ_Z_Y_": "Glückwunsch, Sie erhalten {num} {price} Yuan {name}",
    "QBLX": "Alle Typen",
    "QLQZX": "Zum Gutscheinzentrum",
    "YLYH": "Erhaltene Vorteile",
    "MZTJJKSY": "Bei Erfüllung der Bedingungen anwendbar",
    "GXNHD_Z_YHQ": "Glückwunsch, Sie erhalten {num} Gutscheine",
    "G_Y": "Insgesamt {price} Yuan",
    "XZYHQ": "Gutschein auswählen",
    "PLXD": "Stapelbestellung",
    "FHJL": "Versandrecords",
    "DDTJ": "Bestellungsstatistik",
    "DDGL": "Bestellungsverwaltung",
    "JKWFH": "Nur nicht versendete anzeigen",
    "DDS": "Anzahl der Bestellungen",
    "DGSPS": "Anzahl der bestellten Produkte",
    "THSPS": "Anzahl der zurückgesendeten Produkte",
    "YFHSPS": "Anzahl der versendeten Produkte",
    "WFHSPS": "Anzahl der nicht versendeten Produkte",
    "YFHSPJE": "Betrag der versendeten Produkte",
    "WFHSPJE": "Betrag der nicht versendeten Produkte",
    "WFH": "Nicht versendet",
    "YGJ": "Schätzung",
    "GGBM": "Spezifikationscode",
    "SLHJ": "Mengen总和",
    "JEHJ": "Betrags总和",
    "QPLKY": "Für alle Kategorien anwendbar",
    "KYCXHDDJSY": "Kann mit Promotionsaktionen kombiniert werden",
    "BKDKYF": "Kann nicht für Versandkosten verwendet werden",
    "SYHBYTH": "Nach Verwendung nicht erstattbar",
    "TiJi": "Volumen",
    "ZhongLiang": "Gewicht",
    "ZongTiJi": "Gesamtvolumen",
    "ZongZhongLiang": "Gesamtgewicht",
    "QSRDHDCKDWLDHSJRSJH": "Bitte Bestellnummer/Auslagerungsnummer/Logistiknummer/Empfänger/Handynummer eingeben",
    "CKDH": "Auslagerungsnummer",
    "WLDZT": "Logistikstatus",
    "WLDH": "Logistiknummer",
    "SJR": "Empfänger",
};
export default de_DE
